import _Promise from "@babel/runtime-corejs3/core-js/promise";
import { defineComponent, onMounted, ref } from "@vue/composition-api";
import PageHeader from "@Shared/components/general/page-header.vue";
import ReportsTabs from "./reports-tabs.vue";
import * as ApplicationActions from "@Broker/@Modules/clients/applications/application/store/lender-submit-actions";
import { useApplicationStoreActions } from "@Broker/@Modules/clients/applications/application/store/application-helpers";
import * as AgentActions from "@Broker/@Modules/agents/store/agent-actions";
import { useAgentStoreActions } from "@Broker/@Modules/agents/store/agent-helpers";
import { useReferrerStoreActions } from "../referrers/store/referrer-helpers";
import * as ReferrerActions from "@Broker/js/modules/clients/referrers/store/referrer-actions";
import * as ReportsActions from "@Broker/@Modules/clients/reports/store/reports-actions";
import { useReportsStoreActions } from "@Broker/@Modules/clients/reports/store/reports-helpers";
import UnsyncedAppsModal from "@Broker/@Modules/clients/reports/reports-containers/unsynced-apps-modal.vue";
export default defineComponent({
  name: "ReportsContainer",
  components: {
    ReportsTabs,
    PageHeader,
    UnsyncedAppsModal
  },
  setup() {
    const {
      LOAD_LENDERS
    } = useApplicationStoreActions([ApplicationActions.LOAD_LENDERS]);
    const {
      LOAD_AGENTS
    } = useAgentStoreActions([AgentActions.LOAD_AGENTS]);
    const {
      LOAD_REFERRERS
    } = useReferrerStoreActions([ReferrerActions.LOAD_REFERRERS]);
    const {
      RUN_RENEWAL_TRACKING_REPORT,
      RUN_LENDER_TRANSACTION_REPORT,
      RUN_FIRM_STATISTICS_REPORT,
      RUN_APPLICATION_SUMMARY_REPORT,
      RUN_COMMISSIONS_REPORT,
      RUN_RISK_LEVEL_REPORT
    } = useReportsStoreActions([ReportsActions.RUN_RENEWAL_TRACKING_REPORT, ReportsActions.RUN_LENDER_TRANSACTION_REPORT, ReportsActions.RUN_FIRM_STATISTICS_REPORT, ReportsActions.RUN_APPLICATION_SUMMARY_REPORT, ReportsActions.RUN_COMMISSIONS_REPORT, ReportsActions.RUN_RISK_LEVEL_REPORT]);
    const getRunReportAction = reportType => {
      const reportActionMap = {
        "renewal-tracking": RUN_RENEWAL_TRACKING_REPORT,
        "lender-transaction": RUN_LENDER_TRANSACTION_REPORT,
        "firm-statistics": RUN_FIRM_STATISTICS_REPORT,
        "application-summary": RUN_APPLICATION_SUMMARY_REPORT,
        commissions: RUN_COMMISSIONS_REPORT,
        "risk-level": RUN_RISK_LEVEL_REPORT
      };
      return reportActionMap[reportType];
    };
    const loading = ref(true);
    const nrOfUnsyncedApps = ref(0);
    const unsyncedAppsModal = ref();
    const reportContainer = ref();
    const runningReport = ref({
      loading: false,
      loadingSucceeded: true,
      disabled: false
    });
    const handleRunReport = async ({
      reportType,
      data
    }) => {
      runningReport.value.loading = true;
      const runReportAction = getRunReportAction(reportType);
      const {
        succeeded,
        pending
      } = await runReportAction(data);
      runningReport.value.loading = false;
      if (pending && pending != 0) {
        nrOfUnsyncedApps.value = pending;
        unsyncedAppsModal.value.$showModal();
      } else {
        if (succeeded) reportContainer.value.handleClearSelection();
        runningReport.value.loadingSucceeded = succeeded;
      }
    };
    onMounted(async () => {
      loading.value = true;
      const promises = [LOAD_LENDERS(), LOAD_AGENTS(), LOAD_REFERRERS()];
      await _Promise.all(promises);
      loading.value = false;
    });
    return {
      loading,
      handleRunReport,
      runningReport,
      unsyncedAppsModal,
      reportContainer,
      nrOfUnsyncedApps
    };
  }
});